'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'circle-user';
var width = 512;
var height = 512;
var aliases = [62142,"user-circle"];
var unicode = 'f2bd';
var svgPathData = ['M16 256c0 74.7 34.1 141.3 87.5 185.4L144 320 368 320 408.5 441.4C461.9 397.3 496 330.7 496 256 496 123.5 388.5 16 256 16S16 123.5 16 256zm320-64a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M408.5 441.4L368 320 144 320 103.5 441.4C50.1 397.3 16 330.7 16 256 16 123.5 123.5 16 256 16S496 123.5 496 256c0 74.7-34.1 141.3-87.5 185.4zM395 451.7C355.8 479.6 307.8 496 256 496s-99.8-16.4-139-44.3L155.5 336 356.5 336 395 451.7zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-320a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;